import { useEffect, useState } from 'react';
import type { LeaderboardEntry } from '@xiangqi/protocol';
import { api } from '../api.ts';

interface LeaderboardScreenProps {
  navigate(path: string): void;
}

export function LeaderboardScreen({ navigate }: LeaderboardScreenProps) {
  const [leaders, setLeaders] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.leaderboard()
      .then((res) => {
        if (!cancelled) {
          setLeaders(res.leaderboard);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="page leaderboard-page">
      <header className="page-header">
        <h1>🏆 Bảng Xếp Hạng</h1>
        <p className="page-subtitle">Vinh danh những cao thủ hàng đầu</p>
      </header>

      {loading ? (
        <p className="waiting">Đang tải bảng xếp hạng…</p>
      ) : leaders.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">🎖️</span>
          <h3>Chưa có dữ liệu xếp hạng</h3>
          <p>Hãy là người đầu tiên chiến thắng để ghi tên lên bảng vàng!</p>
          <button className="primary" onClick={() => navigate('/')}>
            Chiến ngay
          </button>
        </div>
      ) : (
        <div className="leaderboard-list">
          {leaders.map((entry) => {
            const medal =
              entry.rank === 1
                ? '🥇'
                : entry.rank === 2
                  ? '🥈'
                  : entry.rank === 3
                    ? '🥉'
                    : `#${entry.rank}`;

            return (
              <div
                key={entry.user_id}
                className={`leader-row ${entry.rank <= 3 ? `top-rank rank-${entry.rank}` : ''}`}
              >
                <div className="leader-rank">{medal}</div>
                <div className="leader-info">
                  <strong>{entry.display_name}</strong>
                  <span className="leader-stats">
                    {entry.wins} thắng / {entry.total_games} trận
                  </span>
                </div>
                <div className="leader-winrate">
                  <span className="rate-num">{entry.win_rate}%</span>
                  <span className="rate-lbl">Tỷ lệ thắng</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </main>
  );
}
